export type UploadRuntimeStage = "uploading" | "viewr_uploading";

export interface UploadRuntimeControl {
  id: string;
  executionId?: string;
  stage: UploadRuntimeStage;
  abort: () => void;
  restart: () => void;
}

const runtimeControls = new Map<string, UploadRuntimeControl>();

export const registerUploadRuntimeControl = (
  control: UploadRuntimeControl
): void => {
  runtimeControls.set(control.id, control);
};

export const clearUploadRuntimeControl = (id: string, executionId?: string): void => {
  if (executionId && runtimeControls.get(id)?.executionId !== executionId) return;
  runtimeControls.delete(id);
};

export const hasUploadRuntimeControl = (id: string): boolean =>
  runtimeControls.has(id);

export const pauseUploadRuntime = (id: string): boolean => {
  const control = runtimeControls.get(id);
  if (!control) return false;
  control.abort();
  return true;
};

export const resumeUploadRuntime = (id: string): boolean => {
  const control = runtimeControls.get(id);
  if (!control) return false;
  control.restart();
  return true;
};

export const cancelUploadRuntime = (id: string): boolean => {
  const control = runtimeControls.get(id);
  if (!control) return false;
  control.abort();
  runtimeControls.delete(id);
  return true;
};
